import { useState, ReactNode } from 'react'
import { Branch } from 'inventory-web'

import { EuiComboBoxProps } from '@equipmentshare/ds2'

import ComboBox from 'components/ComboBox/comboBox'
import FormRow, { FormRowProps } from 'components/FormRow'
import useBranchesSearch from 'hooks/branches-search'

export type BranchPickerProps = {
	id?: string,
	debounceKey?: string,
	label?: ReactNode,
	onChange: ( id?: number, option?: Branch ) => void,
	selectedBranch?: Branch,
	formRowProps?: Partial<FormRowProps>,
	isLoading?: boolean,
} & Partial<Omit<EuiComboBoxProps<Branch>, 'onChange'>>

export default function BranchPicker( { label, selectedBranch, onChange, debounceKey, isLoading, formRowProps, ...props }: BranchPickerProps ) {
	const [ searchString, setSearchString ] = useState( '' )
	const { loading, filteredBranches } = useBranchesSearch( searchString, debounceKey )
	const handleChange = ( branch?: Branch ) => onChange( branch?.id, branch )

	return (
		<FormRow label={label ?? 'Branch'} {...formRowProps}>
			<ComboBox
				debounceDelayMs={400}
				setSearchString={setSearchString}
				setSelectedOption={handleChange}
				data={filteredBranches}
				selectedOption={selectedBranch}
				getName={( branch: Branch ) => branch.name}
				isLoading={loading || isLoading}
				isInvalid={formRowProps?.isInvalid}
				{...props}
			/>
		</FormRow>
	)
}
